import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../config/firebaseConfig";
import "./Navbar.css";
import DropdownMenu from "./DropdownMenu";
import { useDropdownHover } from "../../hooks/useDropdownHover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
faCalendarDays,
faCaretDown,
faFilePen,
faHouse,
faHeadset,
faUser,
faCircleCheck,
faCirclePlus,
faPencil,
faList,
faPlus,
faRightFromBracket,
faRightToBracket,
} from "@fortawesome/free-solid-svg-icons";

const Navbar = ({ isAuth }) => {
const location = useLocation();
const [userDisplayName, setDisplayName] = useState("");
const [projectName, setProjectName] = useState("");
const currentProjectName = localStorage.getItem("currentProjectName") || "未選択";
const [userRole, setUserRole] = useState("");
const [user, setUser] = useState("");

// ▼ ドロップダウン制御フック
const masterDropdown = useDropdownHover(200);
const userDropdown = useDropdownHover(200);
const projectDropdown = useDropdownHover(200);

const isMasterActive =
    location.pathname === "/CreateMaster" ||
    location.pathname === "/master-list" ||
    location.pathname === "/treeViewEdit";

const isUserActive =
    location.pathname === "/join-project" ||
    location.pathname === "/logout";

// ログインユーザー情報
useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
    if (user) {
        setDisplayName(user.displayName || "ログインユーザー");
    } else {
        setDisplayName("");
    }
    });
    return () => unsubscribe();
}, []);

// プロジェクト名の取得
useEffect(() => {
    if (!user) return; // ← ログインしてないときは読み込まない

    const fetchProjectName = async () => {
    const projectID = localStorage.getItem("currentProjectID");
    if (!projectID) return;

    try {
        const docRef = doc(db, "projects", projectID);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
        setProjectName(docSnap.data().name || "プロジェクト未設定");
        } else {
        setProjectName("プロジェクト不明");
        }
    } catch (err) {
        console.error("プロジェクト情報の取得に失敗", err);
        setProjectName("取得失敗");
    }
    };

    fetchProjectName();
}, [user]);

// ロール取得
useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
    if (user) {
        const userDocRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userDocRef);
        if (userSnap.exists()) {
        setUserRole(userSnap.data().role || "user");
        }
    }
    });
    return () => unsubscribe();
}, []);

// ▼ 未ログイン時
if (!isAuth) {
    return (
    <nav className="navbar-container">
        <Link to="/login">
        <FontAwesomeIcon icon={faRightToBracket} /> ログイン
        </Link>
    </nav>
    );
}

// ▼ ログイン時
return (
    <nav className="navbar-container">
    <div className="navbar-left">
        <Link
        to="/UtilityList"
        className={location.pathname === "/UtilityList" ? "active" : ""}
        >
        <FontAwesomeIcon icon={faHouse} /> 原動一覧
        </Link>

        <Link
        to="/gantt"
        className={location.pathname === "/gantt" ? "active" : ""}
        >
        <FontAwesomeIcon icon={faCalendarDays} /> ガントチャート
        </Link>

        <Link
        to="/InquiryForm"
        className={location.pathname === "/InquiryForm" ? "active" : ""}
        >
        <FontAwesomeIcon icon={faHeadset} /> 問合せ
        </Link>

        {/* ▼ マスター編集ドロップダウン ▼ */}
        <DropdownMenu
        label={
            <>
            <FontAwesomeIcon icon={faFilePen} /> マスター編集{" "}
            <FontAwesomeIcon icon={faCaretDown} />
            </>
        }
        {...masterDropdown}
        >
        <Link to="/CreateMaster">
            <FontAwesomeIcon icon={faCirclePlus} /> マスター新規作成
        </Link>
        <Link to="/master-list">
            <FontAwesomeIcon icon={faList} /> マスター情報一覧
        </Link>
        <Link to="/treeViewEdit">
            <FontAwesomeIcon icon={faPencil} /> ツリービュー編集
        </Link>
        </DropdownMenu>
    </div>

    {/* ▼ プロジェクト情報 ▼ */}
    <div className="navbar-project-info">
        <DropdownMenu
        label={
            <span>
            選択プロジェクト <FontAwesomeIcon icon={faCaretDown} />
            <br />
            {projectName || currentProjectName}
            </span>
        }
        {...projectDropdown}
        >
        <Link to="/selectproject">
            <FontAwesomeIcon icon={faCircleCheck} /> プロジェクトの切替
        </Link>

        {userRole === "admin" && (
            <>
            <Link
                to="/projectmanager"
                className={
                location.pathname === "projectmanager" ? "active" : ""
                }
            >
                <FontAwesomeIcon icon={faCirclePlus} /> プロジェクト管理
            </Link>
            {/* <Link
                to="/invite-members"
                className={
                location.pathname === "invite-members" ? "active" : ""
                }
            >
                <FontAwesomeIcon icon={faCirclePlus} /> メンバー招待
            </Link> */}
            </>
        )}
        </DropdownMenu>
    </div>
    
    {/* ▼ ユーザーメニュー ▼ */}
    <div className="navbar-right">
        <DropdownMenu
        label={
            <>
            <FontAwesomeIcon icon={faUser} /> {userDisplayName}{" "}
            <FontAwesomeIcon icon={faCaretDown} />
            </>
        }
        {...userDropdown}
        >
        {/* <Link to="/join-project">
            <FontAwesomeIcon icon={faPlus} /> プロジェクトへの新規参加
        </Link> */}
        <Link to="/logout">
            <FontAwesomeIcon icon={faRightFromBracket} /> ログアウト
        </Link>
        </DropdownMenu>
    </div>


    </nav>
);
};

export default Navbar;
